import styled from '@emotion/styled/macro';
import { transparentize } from 'polished';
import React from 'react';
import { Variables } from '../base/variables';

const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

const Tag = styled.span`
    display: inline-block;
    color: ${Variables.Colors.i20};
    background-color: ${transparentize(0.75, Variables.Colors.i10)};
    border-radius: ${Variables.Rounded.medium};
    padding: 2px 8px;
    font-size: 12px;
    white-space: nowrap;
`;

const EmptyState = styled.span`
    color: ${Variables.Colors.n50};
    font-style: italic;
    font-size: 12px;
`;

interface ITagsProps {
    items?: string[];
    emptyText?: string;
}

export const TagsList: React.FC<ITagsProps> = ({ items, emptyText = '—' }) => {
    if (!items || items.length === 0) {
        return <EmptyState>{emptyText}</EmptyState>;
    }

    return (
        <TagContainer>
            {items.map((item, index) => (
                <Tag key={`${item}-${index}`}>
                    {item}
                </Tag>
            ))}
        </TagContainer>
    );
};

